export const DURATIONS = {
  halfHour: 1000 * 60 * 30,
  oneMinute: 1000 * 60,
  fiveSeconds: 1000 * 5,
  oneSecond: 1000,
  oneDay: 24 * 60 * 60 * 1000,
};
